import { useIsSplitsConnectInstalled } from '~/hooks/useIsSplitsConnectInstalled'
import { isDesktopChromium } from '~/utils/devices'

/**
 * Single source of truth for whether the Splits Connect extension can be
 * installed in this browser: only desktop Chromium browsers can install it from
 * the Chrome Web Store, and only when it isn't already present. Gates both the
 * sidebar "Install extension" help-menu row and the Splits Connect promo card.
 */
export const useCanInstallSplitsConnect = (): boolean => {
  const isExtensionInstalled = useIsSplitsConnectInstalled()
  return isDesktopChromium() && !isExtensionInstalled
}
